import React from 'react';
import { debounce } from 'lodash';
import { checkDiscountCode } from '../api/signup-service.js';

const useDiscountCode = (discountCode) => {
  const [coupon, setCoupon] = React.useState(null);
  const [loading, setLoading] = React.useState(false);
  const [error, setError] = React.useState(null);

  const debouncedCheckCode = React.useMemo(
    () =>
      debounce(async code => {
        if (!code) {
          setCoupon(null);
          return;
        }

        setLoading(true);
        setError(null);

        try {
          const response = await checkDiscountCode({ discountCode: code });
          const { data } = response;

          if (data.isValid) {
            setCoupon(data.coupon);
          }
        } catch (err) {
          setError(err.message || 'Failed to check discount code');
        } finally {
          setLoading(false);
        }
      }, 1000),
    []
  );

  React.useEffect(() => {
    debouncedCheckCode(discountCode);
    return () => debouncedCheckCode.cancel();
  }, [discountCode, debouncedCheckCode]);

  return { coupon, loading, error };
};

export default useDiscountCode;
